import { Button, Modal, notification, Spin } from 'antd';
import moment from 'moment';
import React, { CSSProperties } from 'react';
import { getCredits, ICredit, saveCredit } from 'src/apis/Reporting/Credits';
import 'src/assets/css/creditsModal.css';
import 'src/assets/css/generalStyles.scss';
import CreditsTable from './CreditsTable';

interface ILocalProps {
    companyID: number;
    companyName: string;
    token: string;
    handleSubmit: () => void;
}

interface ILocalState {
    credits: ICredit[];
    currencySymbol: string;
    hasCredits: boolean;
    loading: boolean;
    visible: boolean;
};

class CreditsModal extends React.Component<ILocalProps, ILocalState> {
    public state = { visible: true, credits: [], hasCredits: false, loading: true, currencySymbol: '$' };

    public async componentDidMount() {
        // Get Credit details for the company
        const { companyID, token } = this.props;
        const credits: ICredit[] = await getCredits(companyID, token);
        let currencySymbol: string = '$';
        if (credits.length > 0) {
            this.setState({ credits, hasCredits: true })
            const credit: ICredit = credits[0];
            currencySymbol = credit.creditBalance.charAt(0);
        }
        this.setState({ loading: false, currencySymbol });
    }

    public handleAdd = () => {
        const newCredit: ICredit = {
            childCompanyProfileID: null,
            createTimestamp: moment().format('ddd, MMMM D, YYYY'),
            creditAmount: '$ 0.00',
            creditBalance: '$ 0.00',
            id: `newCredit${this.state.credits.length + 1}`,
            note: '',
            spread: 12,
            type: 0,
        };
        this.setState({ credits: [...this.state.credits, newCredit], hasCredits: true });
    };

    public handleDelete = (id: string) => {
        this.setState({ credits: this.state.credits.filter((credit: ICredit) => credit.id !== id) });
    };

    public handleUpdate = (id: string, newCredit: ICredit, note: string) => {
        const updatedCredits: ICredit[] = [...this.state.credits];
        const index = updatedCredits.findIndex((credit: ICredit) => credit.id.toString() === id);
        updatedCredits.splice(index, 1, {
            ...newCredit,
            note,
        });
        this.setState({ credits: updatedCredits });
    };

    public handleClose = () => {
        this.props.handleSubmit();
    };

    public handleSaveCredit = (credit: ICredit, id: string) => {
        return saveCredit(id, credit, this.props.token, this.props.companyID);
    };

    public getTotalBalance = () => {
      let totalBalance: number = 0;
      this.state.credits.forEach((credit: ICredit) => {
         totalBalance = totalBalance + parseFloat(credit.creditBalance.substr(1).trim());
      });
      return totalBalance;
    };

    public render() {
        const emptyCreditsContainer: CSSProperties = {
            background: "rgba(0,0,0,0.05)",
            borderRadius: 4,
            marginBottom: 20,
            marginTop: 20,
            paddingBottom: 30,
            paddingLeft: 40,
            paddingRight: 40,
            paddingTop: 30,
            textAlign: "center",
        };

        return (
            <Modal
                closable={false}
                title={`Manage Credits For ${this.props.companyName}`}
                visible={this.state.visible}
                className="credits-modal"
                footer={[
                    <Button key="back" style={{ display: 'flex', justifyContent: 'flex-start'}} onClick={this.handleClose}>Close</Button>,
                ]}
            >
                <div className={"flex space-between align-center mb-1"}>
                    <span>Total Balance: {this.state.currencySymbol} {this.getTotalBalance().toFixed(2)}</span>
                    <Button onClick={this.handleAdd}>Add New Credit</Button>
                </div>
                <div style={ this.state.loading || !this.state.hasCredits ? emptyCreditsContainer : {} }>
                    { this.state.loading && <Spin /> }
                    { !this.state.loading && !this.state.hasCredits &&
                        <p style={{ textDecoration: "bold", fontSize: 24, margin: 0, padding: 0}}>
                            No Credit Data Available
                        </p>
                    }
                    { !this.state.loading &&
                        <div style={ this.state.hasCredits ? {} : { display: 'none' }}>
                            <CreditsTable
                                credits={this.state.credits}
                                loading={this.state.loading}
                                handleDelete={this.handleDelete}
                                updateID={this.handleUpdate}
                                handleSaveCredit={this.handleSaveCredit}
                            />
                        </div>
                    }
                </div>
            </Modal>
        );
    }
}

export default CreditsModal;
